import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import { RoleEnum } from '../../../types/customer.types';
import styles from './ProductCard.module.css';

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { loggedInUser } = useAuth();

  // Backend product structure: { id, name, images[], packagingOptions[], categories[], description }
  const productId = product.id || product._id;
  const productName = product.name;
  const productImage = product.images && product.images.length > 0 ? product.images[0] : product.image;
  const productDescription = product.description || '';

  // Handle categories as array or single object for backward compatibility
  const categories = Array.isArray(product.categories)
    ? product.categories
    : (product.category ? [product.category] : []);
  const categoryNames = categories.map(cat => cat?.name).filter(Boolean).join(', ');

  // Use unitPrice from product
  const productPrice = product.unitPrice || 0;

  // Truncate description to ~60 characters
  const truncatedDescription = productDescription.length > 60
    ? productDescription.substring(0, 60) + '...'
    : productDescription;

  const handleCardClick = () => {
    // Navigate to product details page
    navigate(`/product/${productId}`);
  };

  return (
    <div className={styles.card} onClick={handleCardClick}>
      <div className={styles.card__img}>
        <img src={productImage} alt={productName} />
      </div>
      <div className={styles.card__content}>
        <span className={styles.category__tag}>{categoryNames}</span>
        <h6 className={styles.product__name}>{productName}</h6>
        {productDescription && (
          <p className={styles.product__description}>{truncatedDescription}</p>
        )}
        {loggedInUser && loggedInUser.role !== RoleEnum.SELLER ? (
          <div className={styles.card__footer}>
            <div className={styles.price__info}>
              <h4>${productPrice.toFixed(2)}</h4>
            </div>
          </div>
        ) : !loggedInUser ? (
          <div className={styles.card__footer}>
            <div className={styles.price__info}>
              <span style={{ fontSize: '0.65rem' }}>Login to see price</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ProductCard;
